module.exports = __webpack_public_path__ + "static/img/yyotLogo.c51ac1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/yyotLogo.png
// module id = Jv4U
// module chunks = 44